import { Component } from '@angular/core';

import { map } from 'rxjs';

import { SignUpFacadeService } from '../../services/sign-up-facade.service';

@Component({
  selector: 'ib-sign-up-wizard-footer',
  templateUrl: './sign-up-wizard-footer.component.html',
  styleUrls: ['./sign-up-wizard-footer.component.scss'],
})
export class SignUpWizardFooterComponent {
  public isRegistrLoading$ = this.signUpFacadeS.selectIsRegisterLoading();
  public isNextLoading$ = this.signUpFacadeS.selectIsNextLoading();
  public state$ = this.signUpFacadeS
    .selectBtnsState()
    .pipe(map(r => ({ v: r })));
  constructor(public signUpFacadeS: SignUpFacadeService) {
    console.log(
      'state: ',
      this.state$.subscribe({
        next: val => {
          console.log('val: ', val);
        },
      }),
    );
  }

  setNextStep(): void {
    this.signUpFacadeS.setNextStep();
  }

  setPrevStep(): void {
    this.signUpFacadeS.setPrevStep();
  }

  clearAll(): void {
    this.signUpFacadeS.clearAllSteps();
  }

  finish(): void {
    this.signUpFacadeS.finish();
  }
}
